import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';

type IUseContactMethods = () => {
  state: {
    threeLetterCode: string | undefined;
  };
};

/**
 * お問い合わせ手段のコンポーネントフック
 *
 * Cookie に保持しているパートナーコードを取得する
 */
export const useContactMethods: IUseContactMethods = () => {
  const threeLetterCode = getThreeLetterCode();

  return { state: { threeLetterCode } };
};
